import { render, staticRenderFns } from "./donors-table-pagination.vue?vue&type=template&id=2daa17c4&"
import script from "./donors-table-pagination.vue?vue&type=script&lang=js&"
export * from "./donors-table-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports